const threeColumnsReviewSection = [
    {
        selector: '.swiper-container-columns-section',
        path: { filename: 'threeColumnsReviewSection' },
    },
];

export { threeColumnsReviewSection };
